import { HttpRequest, HttpMethod } from "./http";

class AppCatalogCategoryProvider extends HttpRequest {
    list(params) {
        return this.request(HttpMethod.Get, "/api/v1/bo/catalog/categories", params);
    }

    get(id) {
        return this.request(HttpMethod.Get, `/api/v1/bo/catalog/categories/${id}`);
    }

    create(payload) {
        return this.request(HttpMethod.Post, "/api/v1/bo/catalog/categories", payload);
    }

    update(id, payload) {
        return this.request(HttpMethod.Put, `/api/v1/bo/catalog/categories/${id}`, payload);
    }

    remove(id) {
        return this.request(HttpMethod.Delete, `/api/v1/bo/catalog/categories/${id}`);
    }

    // PATCH /api/v1/bo/catalog/categories/:id/visibility  (admin only)
    // body: any subset of {show_web, show_member, show_app} (booleans, ≥ 1)
    // 200 {data: {id, show_web, show_member, show_app, updated_at}}
    // 503 until sql/postgres/2026-10-05-category-channel-visibility.sql is applied.
    //
    // A SEPARATE ENDPOINT and not update() above: PUT carries the whole form
    // (names, image, order); a switch must change one flag and nothing else.
    // Spec: docs/specs/2026-10-05-category-channel-visibility-design.md §4.1
    setVisibility(id, payload) {
        return this.request(HttpMethod.Patch, `/api/v1/bo/catalog/categories/${id}/visibility`, payload);
    }
}

export default AppCatalogCategoryProvider;
